import React from 'react'
import { css } from '@emotion/core'
import { Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, ComposedChart } from 'recharts'
import { MonthlyTrend } from '@/models/survey/nps-summary'

type Props = {
  data: MonthlyTrend[]
}

/**
 * タイムラインチャートコンポーネント
 * 回答率とNPSスコアの時系列推移を表示
 */
export const TimelineChart: React.FC<Props> = ({ data }) => {
  const chartData = data.map(item => ({
    month: item.month,
    answerRate: item.answerRate,
    npsScore: item.npsScore,
  }))

  // 月の表示形式を「YYYY-MM」から「YY/MM」に変換
  const formatMonth = (month: string) => {
    if (!month) return ''
    const parts = month.split('-')
    if (parts.length === 2) {
      const year = parts[0].slice(-2) // 下2桁を取得
      const monthNum = parts[1]
      return `${year}/${monthNum}`
    }
    return month
  }

  return (
    <div css={containerStyle}>
      <ResponsiveContainer height="100%" width="100%" style={{ fontSize: 12, marginTop: 0 }}>
        <ComposedChart data={chartData} margin={{ top: 0, right: 0, bottom: 0, left: 20 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="month" tickFormatter={formatMonth} />
          <Legend verticalAlign="top" height={32} />
          <Tooltip />
          <YAxis yAxisId="answerRate" orientation="left" domain={[0, 100]} label={{ value: '回答率(%)', position: 'top', offset: 16 }} />
          <YAxis yAxisId="nps" orientation="right" domain={[-100, 100]} label={{ value: 'NPS', position: 'top', offset: 16 }} />
          <Line yAxisId="answerRate" type="monotone" dataKey="answerRate" stroke="#0017C1" strokeWidth={2} name="回答率(%)" unit="%" />
          <Line yAxisId="nps" type="monotone" dataKey="npsScore" stroke="#F4710F" strokeWidth={2} name="NPS" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

const containerStyle = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
})
